import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Aplica a la ruta el mismo permiso que ya controla su visibilidad en el menú
 * (los listados `access` de static/data.js), para que escribir la URL a mano no
 * sea una puerta trasera. Debe usarse dentro de <PrivateRoute>.
 */
export const RouteAccess = ({ access, children, redirectTo = '/' }) => {
    const { user } = useSelector((state) => state.user);

    if (!access.includes(user?.typeUser)) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};
